<template>
  <div class="app-container">
    <div class="filter-container">
      <el-radio-group v-model="listQuery.status" @change="doSearch">
        <el-radio-button :label="99">全部状态</el-radio-button>
        <el-radio-button :label="1">跟进中</el-radio-button>
        <el-radio-button :label="2">已到店</el-radio-button>
        <el-radio-button :label="21">自然到店</el-radio-button>
        <el-radio-button :label="22">邀约到店</el-radio-button>
        <el-radio-button :label="10">已试驾</el-radio-button>
        <el-radio-button :label="3">智驾</el-radio-button>
        <el-radio-button :label="4">已订车</el-radio-button>
        <el-radio-button :label="5">已交车</el-radio-button>
        <el-radio-button :label="6">战败</el-radio-button>
        <el-radio-button :label="7">休眠</el-radio-button>
        <!-- <el-radio-button :label="101">企业微信</el-radio-button> -->
        <!-- <el-radio-button :label="8">销服成交</el-radio-button> -->
        <!-- <el-radio-button :label="9">销服退订</el-radio-button> -->
      </el-radio-group>
      <br /><br />
      <el-select class="filter-item" v-model="listQuery.dateType" style="width: 150px;"
        v-if="listQuery.status === 2 || listQuery.status === 3 || listQuery.status === 4 || listQuery.status === 5 || listQuery.status === 6 || listQuery.status === 8 || listQuery.status === 9 || listQuery.status === 10 || listQuery.status === 21 || listQuery.status === 22">
        <el-option label="创建时间" :value="1">
        </el-option>
        <el-option label="操作时间" :value="2">
        </el-option>
      </el-select>
      <el-input class="filter-item" style="width:180px;" placeholder="姓名或手机号" v-model="listQuery.key"></el-input>
      <el-date-picker v-model="listQuery.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-cascader class="filter-item" style="width: 350px;" placeholder="选择经销商" filterable change-on-select
        :show-all-levels="false" :options="dealerOptions" v-model="listQuery.dealerCode">
      </el-cascader>
      <el-select style="width: 200px" multiple class="filter-item" v-model="listQuery.salesLevel" placeholder="经销商等级">
        <el-option v-for="item in salesLevels" :key="item.dataName" :label="item.dataName"
          :value="item.dataName"></el-option>
      </el-select>
      <el-select style="width: 150px" class="filter-item" v-model="listQuery.businessType" multiple placeholder="选择购车类型">
        <el-option v-for="item in businessTypes" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue">
        </el-option>
      </el-select>
      <el-select style="width: 150px" class="filter-item" multiple v-model="listQuery.level" placeholder="选择客户级别">
        <el-option v-for="item in customerLevels" :key="item.dataName" :label="item.dataDisplay" :value="item.dataName">
        </el-option>
      </el-select>
      <!-- <el-select class="filter-item" style="width:180px;" v-model="listQuery.suspendType">
                <el-option label="休眠状态" :value="99">
                </el-option>
                <el-option label="未休眠" :value="0">
                </el-option>
                <el-option label="已休眠" :value="1">
                </el-option>
            </el-select> -->
      <el-select class="filter-item" style="width:180px;" v-model="listQuery.fromType">
        <el-option label="全部" :value="0">
        </el-option>
        <el-option label="线上" :value="1">
        </el-option>
        <el-option label="线下" :value="2">
        </el-option>
      </el-select>
      <el-select style="width: 150px" class="filter-item" multiple v-model="listQuery.onlineSource"
        v-if="listQuery.fromType === 1" placeholder="选择线上来源">
        <el-option v-for="item in importSources" :key="item.dataName" :label="item.dataDisplay" :value="item.dataName">
        </el-option>
      </el-select>

      <el-select style="width: 150px" class="filter-item" multiple v-model="listQuery.fromSource"
        v-if="listQuery.fromType === 2" placeholder="选择线下来源">
        <el-option v-for="item in customerFromSources" :key="item.dataValue" :label="item.dataDisplay"
          :value="item.dataValue">
        </el-option>
      </el-select>

      <el-select class="filter-item" style="width:180px;" multiple v-model="listQuery.series" placeholder="选择意向车系">
        <el-option v-for="item in seriesOptions" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select style="width: 200px" class="filter-item" v-if="dealerTypes2.length > 1 && businessType === 0"
        placeholder="经销商类型" collapse-tags multiple v-model="listQuery.dealerTypes">
        <el-option :label="item.name" v-for="(item, index) in dealerTypes2" :key="index" :value="item.value"></el-option>
      </el-select>
      <el-select placeholder="是否异地购车" style="width: 200px;" class="filter-item" v-model="listQuery.isRemote">
        <el-option v-for="([key,value]) in remoteMap.entries()" :key="key" :label="value" :value="key"></el-option>
      </el-select>
      <el-select class="filter-item" style="width:180px;" v-model="listQuery.isWxUser">
        <el-option label="全部" :value="0">
        </el-option>
        <el-option label="微信客户" :value="2">
        </el-option>
        <el-option label="非微信客户" :value="1">
        </el-option>
      </el-select>
      <el-input class="filter-item" style="width:180px;" v-model.number="listQuery.customerId" placeholder="客户ID" clearable>
      </el-input>
      <el-input class="filter-item" style="width:180px;" v-model.number="listQuery.clueId" placeholder="线索ID" clearable>
      </el-input>

      <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
      <el-button class="filter-item" icon="el-icon-download" @click="doExport">导出</el-button>
    </div>

    <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%" max-height="600">
      <el-table-column align="left" label="创建时间" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="经销商名称" min-width="260">
        <template slot-scope="scope">
          <span>{{ scope.row.dealerName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="姓名" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="电话" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="客户级别" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.level | levelDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="购车类型" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.businessType | businessTypeDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="意向车系" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.specName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="购车地区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.buyCarAddressText }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="是否异地购车" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.isRemote|formatRemote }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="客户经理" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.ownerName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="休眠状态" width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.level === 'N' || scope.row.level === 'H' || scope.row.level === 'A' || scope.row.level ===
            'B' || scope.row.level === 'C') && scope.row.isSuspend ? '已休眠' : '未休眠' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="客户ID" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="线索ID" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.clueId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="渠道" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.fromType === 1">线上: {{ scope.row.onlineSourceName }}</span>
          <span v-if="scope.row.fromType === 2">线下: {{ scope.row.fromSource | fromSourceDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="自定义来源" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.customSourceDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车架号" width="150" v-if="isSuper">
        <template slot-scope="scope">
          <span>{{ scope.row.vin }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="商机ID" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.siebelId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="线索周期" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.days }}天</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="95" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="showTimelineDialog(scope.row)" style="margin-bottom: 10px;">轨迹</el-button>
          <el-button v-if="scope.row.newMediaUrl && scope.row.newMediaUrl.length" size="mini" style="margin-left: 0px;" @click="showSourceVoucher(scope.row)">
            来源凭证</el-button>
          <!-- <el-button size="mini" @click="showSummaryDialog(scope.row)">详情</el-button>
                    <el-button size="mini" @click="showTimelineDialog(scope.row)">轨迹</el-button> -->
          <!-- <el-button type="warning" circle size="mini" icon="el-icon-delete" @click="toDelete(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="viewTitle" :visible.sync="timelineDialog" width="550px">
      <el-table :data="viewData.timelines" border fit highlight-current-row style="width: 100%" max-height="350">
        <el-table-column align="left" label="时间" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="结果">
          <template slot-scope="scope">
            <span>
              <el-row v-if="scope.row.ownerName != ''">
                <el-col :span="5">处理人员:</el-col>
                <el-col :span="19">{{ scope.row.ownerName }}</el-col>
              </el-row>
              <el-row v-if="scope.row.subject != ''">
                <el-col :span="5">处理结果:</el-col>
                <el-col :span="19">{{ scope.row.subject }}</el-col>
              </el-row>
              <el-row v-if="scope.row.content != ''">
                <el-col :span="5">内容:</el-col>
                <el-col :span="19">
                  <span v-html="scope.row.content.replaceAll('\n', '<br/>')"></span>
                  <a v-for="(item, index) in scope.row.images1.split(',')" :key="`images1${index}`" :href="item" target="_blank"><img height=150
                      :src="item" /> </a>
                  <a v-for="(item, index) in scope.row.images2.split(',')" :key="`images2${index}`" :href="item" target="_blank"><img height=150
                      :src="item" /> </a>
                  <a v-for="(item, index) in scope.row.images3.split(',')" :key="`images3${index}`" :href="item" target="_blank"><img height=150
                      :src="item" /> </a>
                </el-col>

              </el-row>
            </span>
          </template>
        </el-table-column>

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="timelineDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <ImageViewer v-if="showViewer" :on-close="() => showViewer = false" :url-list="previewSrcList"/>
  </div>
</template>

<script>
import store from "@/store";
import ImageViewer from "@/components/ImageViewer/index";
const remoteMap = new Map([
  [0,'全部'],
  [1, '是'],
  [2, '否'],
  [3, '空']
])

var dealer_customer_list_vm;
export default {
  name: "DealerCustomerList",
  components: { ImageViewer },
  data() {
    dealer_customer_list_vm = this;
    return {
      remoteMap,
      businessType: store.getters.user.businessType,
      isSuper: store.getters.user.isSuper,
      dealerTypes1: store.getters.user.dealerTypes,
      customerLevels: [],
      customerFromSources: [],
      customerFromSourcesHist: [],
      contactTypes: [],
      businessTypes: [],
      importSources: [],

      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        dateRange: [new Date(), new Date()],
        businessType: [],
        level: [],
        fromSource: [],
        suspendType: 99,
        onlineSource: [],
        key: "",
        fromType: 0,
        isRemote: null,
        dealerCode: [],
        series: [],
        status: 99,
        dateType: 1,
        salesLevel: [],
        dealerTypes: [],
        isWxUser: 0,
        customerId: null,
        clueId: null,
      },

      dealerOptions: [],
      seriesOptions: [],

      timelineDialog: false,
      viewData: {
        deal: {
          timelines: []
        }
      },
      viewTitle: "",
      salesLevels: [
        { dataName: "4S" },
        { dataName: "4S(A)" },
        { dataName: "4S(B)" },
        { dataName: "专营店" },
        { dataName: "体验中心" },
        { dataName: "商超" },
        { dataName: "商超店" },
        { dataName: "城市体验店" },
        { dataName: "城市展厅" },
        { dataName: "销售展厅" }
      ],
      dealerTypes2: [],
      showViewer: false,
      previewSrcList: []
    };
  },
  filters: {
    formatRemote(isRemote) {
      return [1,2].includes(isRemote) ? remoteMap.get(isRemote) : ''
    },
    dealerTypeDisplay(type) {
      const map = {
        1: "王朝",
        2: "海洋"
      };
      return map[type];
    },
    levelDisplay(level) {
      for (var i = 0; i < dealer_customer_list_vm.customerLevels.length; i++) {
        var o = dealer_customer_list_vm.customerLevels[i];
        if (o.dataName === level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    fromSourceDisplay(source) {
      for (
        var i = 0;
        i < dealer_customer_list_vm.customerFromSourcesHist.length;
        i++
      ) {
        var o = dealer_customer_list_vm.customerFromSourcesHist[i];
        if (o.dataValue === source) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    businessTypeDisplay(source) {
      for (var i = 0; i < dealer_customer_list_vm.businessTypes.length; i++) {
        var o = dealer_customer_list_vm.businessTypes[i];
        if (o.dataValue === source) {
          return o.dataDisplay;
        }
      }
      return "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    let dealerTypes = [{ name: "王朝", value: 1 }, { name: "海洋", value: 2 }];
    this.dealerTypes2 = [];
    if (this.dealerTypes1 != "") {
      dealerTypes.forEach(item => {
        if (this.dealerTypes1.split(",").indexOf(String(item.value)) >= 0) {
          this.dealerTypes2.push(item);
        }
      });
    }
    this.retrieveSystemData();
    this.retrieveDealerOptions();
    this.retrieveSeriesOptions();

    this.doReset();
  },
  methods: {
    retrieveSystemData() {
      var parent = this;
      this.$httpAuth.post("/v1/baseRpc/info", {}).then(function (response) {
        parent.customerLevels = response.data.customerLevels;
        parent.customerFromSources = response.data.customerFromSources;
        parent.customerFromSourcesHist = response.data.customerFromSourcesHist;
        parent.contactTypes = response.data.contactTypes;
        parent.businessTypes = response.data.businessTypes;
        parent.importSources = response.data.importSources;
      });
    },
    retrieveDealerOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/jsonTree", {})
        .then(function (response) {
          parent.dealerOptions = response.data.data;
          parent.dealerOptions.unshift({
            label: "全部",
            level: 1,
            value: ""
          });
        });
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/validSeriesList", {})
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        });
    },
    doReset() {
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        dateRange: [new Date(), new Date()],
        businessType: [],
        level: [],
        fromSource: [],
        suspendType: 99,
        onlineSource: [],
        key: "",
        fromType: 0,
        isRemote: null,
        dealerCode: [],
        series: [],
        status: 99,
        dateType: 1,
        salesLevel: [],
        dealerTypes: [],
        isWxUser: 0,
        customerId: null,
        clueId: null,
      };
      if (this.dealerTypes2.length === 1) {
        this.listQuery.dealerTypes.push(this.dealerTypes2[0].value);
      }
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length === 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length === 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length === 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length === 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length === 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      const dateStart =  this.listQuery.dateRange ?  Math.round(this.listQuery.dateRange[0].getTime() / 1000): null
      const dateEnd =  this.listQuery.dateRange ?  Math.round(this.listQuery.dateRange[1].getTime() / 1000): null
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/customerList2", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          dateStart,
          dateEnd,
          levels: this.listQuery.level.join(","),
          key: this.listQuery.key,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          formType: this.listQuery.fromType,
          isRemote:  this.listQuery.isRemote,
          fromSource: this.listQuery.fromSource.join(","),
          onlineSource: this.listQuery.onlineSource.join(","),
          businessType: this.listQuery.businessType.join(","),
          series: this.listQuery.series.join(","),
          isExport: false,
          suspendType: this.listQuery.suspendType,
          status: this.listQuery.status + "",
          dateType: this.listQuery.dateType,
          dealerLevel: this.listQuery.salesLevel.join(","),
          dealerTypes:
            this.listQuery.dealerTypes.length != 0
              ? this.listQuery.dealerTypes.join(",")
              : "",
          isWxUser: this.listQuery.isWxUser,
          customerId: this.listQuery.customerId || null,
          clueId: this.listQuery.clueId || null,
        })
        .then(function (response) {
          parent.listLoading = false;
          var data = response.data.data;
          for (var i = 0; i < data.length; i++) {
            // 购车地区
            const {buyProvince,buyCity,buyArea} = data[i]
            data[i].buyCarAddressText = [buyProvince,buyCity,buyArea].filter(item => !!item).join('/')
          }
          parent.list = data;
          console.log(data, 'list===table');
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showSourceVoucher(row) {
      this.showViewer = true
      this.previewSrcList = row.newMediaUrl.map(n=>n.image)
    },
    showTimelineDialog(row) {
      this.timelineDialog = true;
      this.viewData = row;
      this.viewTitle = row.name + " - " + row.mobile;
      // for (let i = 0; i < this.viewData.deal.timelines.length; i++) {
      //     var timeline = this.viewData.deal.timelines[i]
      //     if (timeline.images1 != '') {
      //       timeline.images1 = timeline.images1.split(",")
      //     }
      //     if (timeline.images2 != '') {
      //       timeline.images2 = timeline.images2.split(",")
      //     }
      //     if (timeline.images3 != '') {
      //       timeline.images3 = timeline.images3.split(",")
      //     }
      //     console.log(timeline)
      // }
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length === 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length === 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length === 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length === 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length === 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      const dateStart =  this.listQuery.dateRange ?  Math.round(this.listQuery.dateRange[0].getTime() / 1000): null
      const dateEnd =  this.listQuery.dateRange ?  Math.round(this.listQuery.dateRange[1].getTime() / 1000): null
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/customerExport2", {
          dateStart,
          dateEnd,
          levels: this.listQuery.level.join(","),
          key: this.listQuery.key,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          formType: this.listQuery.fromType,
          isRemote:  this.listQuery.isRemote,
          fromSource: this.listQuery.fromSource.join(","),
          onlineSource: this.listQuery.onlineSource.join(","),
          businessType: this.listQuery.businessType.join(","),
          series: this.listQuery.series.join(","),
          suspendType: this.listQuery.suspendType,
          status: this.listQuery.status + "",
          dateType: this.listQuery.dateType,
          dealerLevel: this.listQuery.salesLevel.join(","),
          dealerTypes:
            this.listQuery.dealerTypes.length != 0
              ? this.listQuery.dealerTypes.join(",")
              : "",
          isWxUser: this.listQuery.isWxUser,
          customerId: this.listQuery.customerId || null,
          clueId: this.listQuery.clueId || null,
        })
        .then(function (response) {
          console.log(response.data);
          setTimeout(() => {
            loading.close();
            parent.$message({
              message: "导出任务已产生，请到 平台管理-导出任务 中查看",
              type: "success"
            });
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>
